import { render, staticRenderFns } from "./kpGEMPkg.vue?vue&type=template&id=19d3b2e0"
import script from "./kpGEMPkg.vue?vue&type=script&lang=js"
export * from "./kpGEMPkg.vue?vue&type=script&lang=js"
import style0 from "./kpGEMPkg.vue?vue&type=style&index=0&id=19d3b2e0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d3b2e0')) {
      api.createRecord('19d3b2e0', component.options)
    } else {
      api.reload('19d3b2e0', component.options)
    }
    module.hot.accept("./kpGEMPkg.vue?vue&type=template&id=19d3b2e0", function () {
      api.rerender('19d3b2e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/kpDataViewer/kpGEMPkg.vue"
export default component.exports